// Shared entry point for ad-hoc frontend posthog.capture() calls (e.g. map pin
// clicks) that happen outside the posthog Stimulus controller. Mirrors the
// backend's posthog_track guard: no-op while an admin is masquerading, so
// admin QA never pollutes a real user's PostHog profile.
export function posthogTrack(event: string, props: Record<string, unknown> = {}) {
  if (typeof window === 'undefined' || typeof (window as any).posthog === 'undefined') return;
  if (document.body.dataset.posthogMasquerading === 'true') return;

  (window as any).posthog.capture(event, props);
}
